import { render } from "./NgoDataEntry.vue?vue&type=template&id=40921708&scoped=true"
import script from "./NgoDataEntry.vue?vue&type=script&lang=js"
export * from "./NgoDataEntry.vue?vue&type=script&lang=js"

import "./NgoDataEntry.vue?vue&type=style&index=0&id=40921708&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40921708"]])

export default __exports__